import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';

export interface DialogData {
  erro: HttpErrorResponse;
  mensagem: string;
  titulo: string;
}

@Component({
  selector: 'info-dialog',
  templateUrl: 'info-dialog.component.html',
  imports: [MatDialogContent, MatDialogTitle, MatDialogActions],
})
export class InfoDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

  }

  ngOnInit() {
    let innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
      this.dialogRef.updateSize('80%');
    }
    else {
      this.dialogRef.updateSize('40%');
    }

  }

  onOkClick(): void {
    this.dialogRef.close();
  }
}
